import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const LazyHomepageCard: LoadableType<{
	showCalendarEmptyStateBanner?: boolean;
	keepCalendarEmptyStateBannerVisible?: boolean;
	onEmptyStateChange?: (isEmptyState: boolean | null) => void;
}> = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-HomepageCard" */ './HomepageCard.tsx'))
			.HomepageCard,
});
